import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  max-width: 40rem;

  p {
    font-size: 1.4rem;
    color: #666;
  }
`;

export const WrapperGroupInput = styled.div`
  margin-top: 3rem;

  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 2rem;
`;
